import { css } from "lit";
const packageOfferStyles = css`
  :host {
    display: flex;
    flex-direction: column;
  }

  offer-header {
    --default-vi-font-xl: var(--vi-multi-offer-header-font-size); 
  }

  #package-offer-header {
    display: flex;
    width: 100%;
  }

  #package-offer-header promotional-header {
    flex: 1;
  }

  #offer-display offer-accordion-header {
    display: none;
  }

  @media (max-width: 700px) {
    #offer-display {
      padding: 16px;
    }

    #offer-display offer-header { 
      display: none;
    }

    #offer-display offer-accordion-header, 
    #offer-display.selected offer-accordion-header  {
      display: block;
    }

    #offer-display section#actions {
      display: none;
    }

    #offer-display #offer-content {
      display: none;
    }

    #offer-tag {
      display: none;
    }

    #offer-display promotional-description, 
    #offer-display #offer-content peril-list {
      display: none;
    }

    #offer-display.selected promotional-description, 
    #offer-display.selected #offer-content,
    #offer-display.selected #offer-content peril-list {
      display: block;
    }
  }
`;
export {
  packageOfferStyles as default
};
